<template>
  <div>
    <b-card class="border-none">
      <modal :show.sync="editModal" header-classes="bg-primary p-3">
        <h6 slot="header" class="modal-title text-white font-semibold pt-1">
          Edit Session Date
        </h6>
        <div>
          <div class="my-4 w-full flex">
            <div class="my-4 w-1/2 pr-2">
              <b-form-group label="Date:">
                <date-picker
                  slot-scope="{ focus, blur }"
                  @on-open="focus"
                  @on-close="blur"
                  required
                  :config="{ allowInput: true }"
                  placeholder="Select Date"
                  v-model="editDate"
                  class="cust-wfull"
                  valueType="format"
                >
                </date-picker>
              </b-form-group>
            </div>

            <div class="my-4 w-1/2 pl-2">
              <b-form-group label="Start Time:">
                <date-picker
                  v-model="editStartTime"
                  format="HH:mm"
                  value-type="format"
                  type="time"
                  class="cust-wfull"
                  :config="configdateTimePicker"
                  placeholder="HH:mm"
                >
                </date-picker>
              </b-form-group>
            </div>

            <div class="my-4 w-1/2 pl-2">
              <b-form-group label="End Time:">
                <date-picker
                  v-model="editEndTime"
                  format="HH:mm"
                  value-type="format"
                  type="time"
                  class="cust-wfull"
                  :config="configdateTimePicker"
                  placeholder="HH:mm"
                >
                </date-picker>
                <!-- <span v-if="timeError" class="text-danger fsize12">{{
                  msg.time
                }}</span> -->
              </b-form-group>
            </div>
          </div>
        </div>
        <!-- <button >Submit</button> -->
        <!-- <AddPageDetail /> -->
        <div>
          <span v-if="dayError" class="text-danger fsize12">{{
            msg.date
          }}</span>
          <span v-if="timeError" class="text-danger fsize12">{{
            msg.time
          }}</span>
        </div>
        <template slot="footer">
          <base-button type="primary" @click="editSession"
            >SAVE CHANGES</base-button
          >
          <base-button
            type="secondary"
            class="ml-auto"
            @click="editModal = false"
            >CLOSE</base-button
          >
        </template>
      </modal>

      <div class="flex justify-between items-center mb-8">
        <div>
          <h2 class="text-2xl font-semibold">Session Dates</h2>

          <!-- <small class=" text-muted "
            >Lorem ipsum dolor sit amet, consectetur adipiscing elit,
          </small> -->
        </div>
        <div class="flex">
          <base-button outline class="px-6 py-1 mx-1" type="primary">
            <span
              class="btn-inner--text flex justify-between items-center"
              @click="isShowApplicationclose"
              ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon
              >Add</span
            >
          </base-button>
        </div>
      </div>
      <!-- <h2 class="text-xl font-semibold">
        Application Close By : <span>11-02-2023</span>
      </h2> -->
      <!-- <b-input-group class="mt-12">
        <b-form-input
          class="border-none shadow-lg"
          type="text"
          min="0.00"
          placeholder="Enter Search...."
        ></b-form-input> 

        <b-input-group-append>
          <b-button
            variant="white"
            class="flex items-center shadow-lg"
            aria-label="search"
          >
            <feather-icon
              class="cursor-pointer mr-2"
              icon="SearchIcon"
              svgClasses="w-4 h-4"
            ></feather-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group> -->

      <el-table
        class="table-responsive table-flush mt-6"
        header-row-class-name="thead-light table-th-color"
        :data="coachsession"
        border
      >
        <el-table-column label="Date" min-width="170px" prop="date" sortable>
          <template v-slot="{ row }">
            <span class="text-black font-medium">{{
              row.date | moment("dddd, MMMM Do YYYY")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Day" prop="end" min-width="130px" sortable>
          <template v-slot="{ row }">
            <span class="text-black font-medium">{{
              row.day | moment("dddd")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Start time"
          min-width="170px"
          prop="date"
          sortable
        >
          <template v-slot="{ row }">
            <span class="text-black font-medium">{{ row.starttime }}</span>
          </template>
        </el-table-column>

        <el-table-column label="End Time" prop="end" min-width="130px" sortable>
          <template v-slot="{ row }">
            <span class="text-black font-medium">{{ row.endtime }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="Edited By"
          prop="editedby"
          min-width="130px"
          sortable
        >
          <template v-slot="{ row }">
            <p
              class="font-semibold text-left name mb-0 text-sm"
              v-if="row.isEdited"
            >
              {{
                row.editedBy.at(-1)._user.firstname +
                  " " +
                  row.editedBy.at(-1)._user.lastname || " "
              }}
            </p>
          </template>
        </el-table-column>

        <!-- <el-table-column label="Name" min-width="150px" prop="name" sortable>
          <template v-slot="{ row }">
            <span class="text-black">{{ row.name }}</span>
          </template>
        </el-table-column> -->

        <el-table-column property="action" label="Action" width="">
          <template v-slot="{ row }">
            <div class="flex items-center">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5"
                class="cursor-pointer text-primary"
                @click="handleEdit(row)"
              />
              <feather-icon
                svgClasses="w-5 h-5"
                class="ml-2 cursor-pointer text-danger"
                icon="Trash2Icon"
                @click="handleDelete(row)"
              />
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- <b-card-footer class="py-4 d-flex justify-content-end">
        <base-pagination
          v-model="currentPage"
          :per-page="10"
          :total="50"
        ></base-pagination>
      </b-card-footer> -->
    </b-card>
  </div>
</template>
<script>
// import "../../scss/Index.scss";
import DatePicker from "vue2-datepicker";
import { ChevronLeftIcon } from "vue-feather-icons";
import Data from "./components/Data";
import { mapState } from "vuex";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    ChevronLeftIcon,
    DatePicker,
  },
  data() {
    return {
      Data,
      currentPage: 1,
      editModal: false,
      openAddBannerSidebar: false,
      approve: false,
      dayError: false,
      timeError: false,
      msg: {},
      editStartTime: "",
      editEndTime: "",
      editDate: "",
      editId: "",
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
      },
    };
  },
  methods: {
    async handleDelete(row) {
      const result = await this.deleteAlert();
      if (result.isConfirmed) {
        this.deleteData(row);
      }
    },
    handleEdit(val) {
      this.timeError = false;
      this.dayError = false;
      try {
        this.editModal = true;
        this.editDate = val.date;
        this.editStartTime = val.starttime;
        this.editEndTime = val.endtime;
        this.editId = val._id;
      } catch (error) {
        console.log(error);
      }
    },
    deleteAlert() {
      return this.$swal({
        title: "Are you sure?",
        html: `<p class="text-center">You won't be able to revert this!</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#830c81",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
    },
    async deleteData(row) {
      let payload = {
        _id: row._id,
      };
      let loader = this.$loading();
      try {
        const deletedata = await this.$store.dispatch(
          "coach/DeleteSession",
          payload
        );
        loader.close();
        if (deletedata.code == 200) {
          this.$swal.fire({
            text: "Session successsfully ended",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          await this.$store.dispatch("coach/GetSession");
        }
      } catch (err) {
        console.log(err);
        loader.close();
      }
    },
    isShowAddCoach() {
      this.$router.push({ name: "add-coach" });
    },
    isShowApplicationclose() {
      this.$router.push({ name: "application-close" });
    },
    add() {
      this.toggleAddBannerSidebar(true);
    },
    toggleAddBannerSidebar(val = false) {
      this.openAddBannerSidebar = val;
    },

    async editSession() {
      // console.log(this.editDate);
      // console.log(this.editStartTime);
      // console.log(this.editEndTime);
      this.timeError = false;
      this.dayError = false;

      this.day = new Date();
      let payload = {
        date: this.editDate,
        day: this.editDate,
        starttime: this.editStartTime,
        endtime: this.editEndTime,
        _id: this.editId,
      };
      let today = new Date();
      today =
        today.getFullYear() +
        "-" +
        ((today.getMonth() + 1).length != 2
          ? "0" + (today.getMonth() + 1)
          : today.getMonth() + 1) +
        "-" +
        today.getDate();
      // console.log(today);
      try {
        this.dayError = false;
        this.timeError = false;

        if (!this.editDate) {
          this.dayError = true;
          this.timeError = false;
          this.msg.date = "Date should be added";
        } else if (this.editDate < today) {
          this.dayError = true;
          this.timeError = false;
          this.msg.date = "Enter valid date";
        } else if (this.editStartTime > this.editEndTime) {
          this.timeError = true;
          this.dayError = false;
          this.msg.time = "Start Time and End Time should be valid";
        } else if (this.editStartTime === this.editEndTime) {
          this.timeError = true;
          this.dayError = false;
          this.msg.time = "Start Time and End Time should be different";
        } else {
          this.timeError = false;
          this.dayError = false;
          let data = await this.$store.dispatch("coach/EditSession", payload);
          this.$router.push({ name: "admin-sessiondates" });
          if (data.code == 200) {
            this.$swal.fire({
              text: "Your session has been successfully added",
              icon: "success",
              confirmButtonText: "Okay",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            });
            await this.$store.dispatch("coach/GetSession");
            this.editModal = false;
          }
        }
      } catch (err) {
        console.log(err);
        // loader.close();
      }
    },
  },
  computed: {
    ...mapState("coach", {
      coachsession: "coachsession",
    }),
  },
  async created() {
    try {
      await this.$store.dispatch("coach/GetSession");
    } catch (err) {
      console.log(err);
    }
  },
};
</script>
